import React, { useState } from 'react';
import HeroSection from './sections/HeroSection';
import PainPointsSection from './sections/PainPointsSection';
import IntroductionSection from './sections/IntroductionSection';
import FeaturesSection from './sections/FeaturesSection';
import SolutionsSection from './sections/SolutionsSection';
import TransformationSection from './sections/TransformationSection';
import BeforeAfterSection from './sections/BeforeAfterSection';
import SocialProofSection from './sections/SocialProofSection';
import PricingSection from './sections/PricingSection';
import CTASection from './sections/CTASection';
import FAQSection from './sections/FAQSection';
import FinalClosingSection from './sections/FinalClosingSection';
import StickyButton from './common/StickyButton';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeroSection />
      <PainPointsSection />
      <IntroductionSection />
      <FeaturesSection />
      <SolutionsSection />
      <TransformationSection />
      <BeforeAfterSection />
      <SocialProofSection />
      <PricingSection />
      <CTASection />
      <FAQSection />
      <FinalClosingSection />
      <StickyButton />
    </div>
  );
};

export default HomePage;